module.exports = __webpack_public_path__ + "static/gari-sq-f9f2418e92da7f9176ff3218a356850e.png";